import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * Sticky in-app nudge to enable two-factor authentication after
 * signup. Dismissable for the current page-load only (component
 * state, NOT localStorage) and explicitly reset on every route
 * change, so the suggestion reappears on the next navigation until
 * the user actually enrols. 2FA is high-value enough that a stale
 * banner is far cheaper than an unprotected account.
 */
export function TwoFactorNudgeBanner() {
  const { user } = useAuth();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);
  // Reset the dismissal on every route change so the banner comes
  // back on the next page-load.
  useEffect(() => {
    setDismissed(false);
  }, [location.pathname]);
  if (!user || user.twoFactorEnabled || dismissed) return null;
  // Don't bother on the settings page itself.
  if (location.pathname === '/settings/account') return null;
  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="mx-auto max-w-6xl px-6 py-2 flex items-center justify-between gap-4">
        <div className="text-sm text-amber-900">
          Protect your account with two-factor authentication.{' '}
          <Link to="/settings/account" className="font-semibold underline">
            Set it up
          </Link>
          .
        </div>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="text-amber-700 hover:text-amber-900 text-sm"
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
